class MacaronCustomizer {
    constructor(opts = {}) {
        this.canvasElId = opts.canvasElId || 'macaronCanvas';
        this.stickersContainerId = opts.stickersContainerId || 'stickers-container';
        this.occasionOptionsId = opts.occasionOptionsId || 'occasionOptions';
        this.selectedOccasion = opts.selectedOccasion || (window.selectedOccasion || '');
        this.canvas = null;
        this.stickersByOccasion = {};
        this.currentStickerObject = null;
        this.stickerLoadRequestId = 0;
        this.currentLanguage = window.currentLanguage || 'en';
        this.init();
    }

    init() {
        this.initCanvas();
        this.setupMacaronOptions();
        this.setupOccasionData();
        this.buildOccasionOptions();
        this.setupCustomDropdowns();
        this.loadStickersForOccasion(this.selectedOccasion);
        this.setupStickerClicksDelegation();
        this.setupTextControls();
        this.setupTabs();
        this.setupAddToCart();
        this.setupPickr();
        this.autoSelectFirsts();
    }

    initCanvas() {
        this.canvas = new fabric.Canvas(this.canvasElId, { preserveObjectStacking: true });
    }

    // Load macaron background image and set as canvas background
    loadMacaronImage(macaronUrl) {
        if (!macaronUrl) return;
        fabric.Image.fromURL(macaronUrl, (img) => {
            const w = this.canvas.getWidth();
            const h = this.canvas.getHeight();
            img.set({
                selectable: false,
                evented: false,
                scaleX: w / img.width,
                scaleY: h / img.height
            });
            this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas));
        }, { crossOrigin: 'anonymous' });
    }

    setupMacaronOptions() {
        const btns = document.querySelectorAll(".macaron-option");
        btns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const macaronImageUrl = btn.getAttribute('data-image');
                this.loadMacaronImage(macaronImageUrl);

                // reset active classes
                document.querySelectorAll(".macaron-box-item").forEach(img => img.classList.remove("active"));
                const parent = btn.closest(".macaron-box-item");
                if (parent) parent.classList.add('active');
            });
        });
    }

    setupOccasionData() {
        // Prefer language-specific data if provided
        if (window.occasionsData && window.occasionsData[this.currentLanguage]) {
            this.stickersByOccasion = window.occasionsData[this.currentLanguage];
        } else if (window.occasionsData && window.occasionsData['en']) {
            this.stickersByOccasion = window.occasionsData['en'];
        } else {
            // default fallback
            this.stickersByOccasion = {
                "Birthdays": [
                    {
                        title: "Happy Birthday sticker 1",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-1.png?v=1750861860"
                    },
                    {
                        title: "Happy Birthday sticker 2",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-2.png?v=1750861861"
                    },
                    {
                        title: "Happy Birthday sticker 3",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-3.png?v=1751978666"
                    },
                    {
                        title: "Happy Birthday sticker 4",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-4.png?v=1750861863"
                    },
                    {
                        title: "Happy Birthday sticker 5",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-5.png?v=1750861864"
                    },
                    {
                        title: "Happy Birthday sticker 6",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-6.png?v=1750861865"
                    },
                    {
                        title: "Happy Birthday sticker 7",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-7.png?v=1750861866"
                    },
                    {
                        title: "Happy Birthday sticker 8",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-8.png?v=1750861867"
                    },
                    {
                        title: "Happy Birthday sticker 9",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-9.png?v=1750861868"
                    },
                    {
                        title: "Happy Birthday sticker 10",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-10.png?v=1750861869"
                    },
                    {
                        title: "Happy Birthday sticker 11",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-11.png?v=1750861870"
                    },
                    {
                        title: "Happy Birthday sticker 12",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/Happy-Birthday-12.png?v=1750861871"
                    }
                ],
                "Love": [
                    {
                        title: "Love Sticker 1",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/love-1.png?v=1751979689"
                    },
                    {
                        title: "Love Sticker 2",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/love-2.png?v=1751979547"
                    },
                    {
                        title: "Love Sticker 3",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/love-3.png?v=1750862431"
                    },

                    {
                        title: "Love Sticker 5",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/love-5.png?v=1750862431"
                    },
                    {
                        title: "Love Sticker 6",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/love-6.png?v=1750862431"
                    },
                    {
                        title: "Love Sticker 7",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/love-7.png?v=1750862431"
                    }

                ],
                "Easter": [
                    {
                        title: "Easter Sticker 1",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/easter-1.png?v=1750917326"
                    },
                    {
                        title: "Easter Sticker 2",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/easter-2.png?v=1751979926"
                    },
                    {
                        title: "Easter Sticker 3",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/easter-3.png?v=1750917326"
                    },
                    {
                        title: "Easter Sticker 4",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/easter-4.png?v=1750917326"
                    }
                ],
                "Valentine": [
                    {
                        title: "Valentine Sticker 1",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-1.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 2",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-2.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 3",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-3.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 4",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-4.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 5",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-5.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 6",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-6.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 7",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-7.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 8",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-8.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 9",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-9.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 10",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-10.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 11",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-11.png?v=1750917780"
                    },
                    {
                        title: "Valentine Sticker 12",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/valentine-12.png?v=1750917780"
                    },

                ],
                "New-Year": [
                    {
                        title: "Happy New Year Sticker 1",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/happy-new-year-1.png?v=1750918084"
                    },
                    {
                        title: "Happy New Year Sticker 2",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/happy-new-year-2.png?v=1750918084"
                    },
                    {
                        title: "Happy New Year Sticker 3",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/happy-new-year-3.png?v=1750918084"
                    }
                ],
                "Christmas": [
                    {
                        title: "Christmas Sticker 1",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/christmas-1.png?v=1750918526"
                    },
                    {
                        title: "Christmas Sticker 2",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/christmas-2.png?v=1750918526"
                    },
                    {
                        title: "Christmas Sticker 3",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/christmas-3.png?v=1751980299"
                    },
                    {
                        title: "Christmas Sticker 4",
                        image: "https://cdn.shopify.com/s/files/1/0251/4845/7040/files/christmas-4.png?v=1750918526"
                    }
                ]
            };
        }
    }


    buildOccasionOptions() {
        const occasionOptions = document.getElementById(this.occasionOptionsId);
        if (!occasionOptions) return;
        occasionOptions.replaceChildren(occasionOptions.firstElementChild);
        const result = {};
        const source = (window.occasionsData && window.occasionsData['en']) || this.stickersByOccasion;
        for (const key in source) {
            if (source.hasOwnProperty(key)) {
                const arr = source[key];
                if (Array.isArray(arr) && arr[0] && arr[0].image) {
                    result[key] = arr[0].image;
                }
            }
        }

        for (const occasion in result) {
            if (!result.hasOwnProperty(occasion)) continue;
            const optionContainer = document.createElement('div');
            optionContainer.classList.add('dropdown-option');
            optionContainer.setAttribute('data-title', occasion);
            optionContainer.setAttribute('data-img', result[occasion]);

            const img = document.createElement('img');
            img.src = result[occasion];
            img.alt = `${occasion} sticker`;
            img.height = 30;
            img.width = 30;

            const span = document.createElement('span');
            span.textContent = occasion;

            optionContainer.appendChild(img);
            optionContainer.appendChild(span);
            occasionOptions.appendChild(optionContainer);
        }
    }

    setupCustomDropdowns() {
        document.querySelectorAll(".custom-dropdown").forEach(dropdown => {
            const selected = dropdown.querySelector(".selected-item");
            const options = dropdown.querySelector(".dropdown-options");
            const hiddenOccasionInput = document.getElementById("occasionInput");
            const hiddenpersonalisationInput = document.getElementById("personalisationInput");
            const ctype = dropdown.dataset.type;

            // toggle dropdown open/close
            selected?.addEventListener("click", () => {
                document.querySelectorAll(".custom-dropdown").forEach(d => {
                    if (d !== dropdown) d.classList.remove("open");
                });
                dropdown.classList.toggle("open");
            });

            // options click
            options?.querySelectorAll(".dropdown-option").forEach(option => {
                option.addEventListener("click", () => {
                    const selectedHtml = option.innerHTML;
                    const chevron = selected.querySelector("svg")?.outerHTML || "";
                    selected.innerHTML = selectedHtml + chevron;
                    dropdown.classList.remove("open");

                    if (ctype === "occasion") {
                        if (hiddenOccasionInput) hiddenOccasionInput.value = option.getAttribute("data-title") || '';
                        if (option.getAttribute("data-title")) this.setProgressStep(1); else this.setProgressStep(0);
                        this.clearOccasionValidation();
                    }

                    if (ctype === "personalisation") {
                        if (hiddenpersonalisationInput) hiddenpersonalisationInput.value = option.getAttribute("data-title") || '';
                        if (option.getAttribute("data-title")) this.setProgressStep(2);
                    }

                    const pval = document.getElementById("personalisationInput")?.value;
                    if (pval === 'sticker') {
                        this.loadStickersForOccasion(hiddenOccasionInput?.value || '');
                    }
                });
            });
        });

        document.addEventListener("click", (e) => {
            document.querySelectorAll(".custom-dropdown").forEach(dropdown => {
                if (!dropdown.contains(e.target)) dropdown.classList.remove("open");
            });
        });
    }

    getOccasionValidationElements() {
        const dropdown = document.getElementById('occasionDropdown');
        const selector = dropdown?.closest('.occasion-selector');
        let errorEl = document.getElementById('occasionValidationError');

        if (!errorEl && selector) {
            errorEl = document.createElement('p');
            errorEl.id = 'occasionValidationError';
            errorEl.className = 'error';
            errorEl.style.display = 'none';
            selector.appendChild(errorEl);
        }

        return { dropdown, errorEl };
    }

    showOccasionValidation() {
        const messages = {
            en: 'Please select an occasion before adding to cart.',
            fr: 'Veuillez selectionner une occasion avant d\'ajouter au panier.',
            de: 'Bitte waehlen Sie einen Anlass aus, bevor Sie den Artikel in den Warenkorb legen.'
        };
        const { dropdown, errorEl } = this.getOccasionValidationElements();

        if (dropdown) {
            dropdown.classList.add('has-error');
        }

        if (errorEl) {
            errorEl.textContent = messages[this.currentLanguage] || messages.en;
            errorEl.style.display = 'block';
        }
    }

    clearOccasionValidation() {
        const { dropdown, errorEl } = this.getOccasionValidationElements();

        if (dropdown) {
            dropdown.classList.remove('has-error');
        }

        if (errorEl) {
            errorEl.textContent = '';
            errorEl.style.display = 'none';
        }
    }

    // loads sticker grid for given occasion
    loadStickersForOccasion(occasion, binds = 0) {

        const container = document.getElementById(this.stickersContainerId);
        const input = document.getElementById("stickerInput");
        if (!container) return;
        container.innerHTML = '';

        const stickers = (this.stickersByOccasion && this.stickersByOccasion[occasion]) || [];

        const divParent = document.createElement("div");
        divParent.className = "sticker-option-wrapper";

        if (stickers.length > 0) container.appendChild(divParent);

        stickers.forEach((sticker, index) => {
            const div = document.createElement("div");
            div.className = "sticker-option";
            div.id = `sticker-option-${index + 1}`;
            // NOTE: no per-element click handler here — we rely on delegation below
            div.innerHTML = `<img src="${sticker.image}" alt="${sticker.title}">`;
            divParent.appendChild(div);
        });

        this.setupStickerClicksDelegation();


        if (binds === 0) {
            setTimeout(() => {
                const first = container.querySelector('.sticker-option');
                if (first) {
                    first.click();
                }
            }, 0);
        }
    }

    // binds click listeners to the stickers (kept for backward compatibility)
    bindStickerClicks(binds = 0) {
        document.querySelectorAll(`#${this.stickersContainerId} .sticker-option`).forEach(stickerDiv => {
            stickerDiv.addEventListener('click', () => {
                const image = stickerDiv.querySelector('img');
                const url = image?.getAttribute('src');
                if (url) this.addStickerToCanvas(url);
            });
        });

        if (binds === 0) {
            const first = document.getElementById('sticker-option-1');
            if (first) first.click();
        }
    }


    setupStickerClicksDelegation() {
        const container = document.getElementById(this.stickersContainerId);
        if (!container) return;

        if (this._stickerClickHandler) {
            container.removeEventListener('click', this._stickerClickHandler);
        }

        this._stickerClickHandler = (e) => {
            const opt = e.target.closest('.sticker-option');
            if (!opt || !container.contains(opt)) return;

            container.querySelectorAll('.sticker-option').forEach(el => el.classList.remove('selected'));
            opt.classList.add('selected');

            const img = opt.querySelector('img');
            const title = img?.getAttribute('alt') || '';
            const src = img?.getAttribute('src') || '';
            const input = document.getElementById("stickerInput");
            if (input) input.value = `${title} | ${src}`;

            if (src) {
                this.addStickerToCanvas(src);
            }


        };

        container.addEventListener('click', this._stickerClickHandler);
    }

    // add sticker image to fabric canvas
    addStickerToCanvas(imageUrl) {
        const requestId = ++this.stickerLoadRequestId;

        if (this.currentStickerObject) {
            this.canvas.remove(this.currentStickerObject);
            this.currentStickerObject = null;
        }

        fabric.Image.fromURL(imageUrl, (img) => {
            if (requestId !== this.stickerLoadRequestId) return;

            const scale = 0.6;
            img.set({
                scaleX: scale,
                scaleY: scale,
                hasRotatingPoint: false,
                cornerStyle: 'circle',
                cornerColor: '#7d4dbb',
                editable: false,
                hasControls: false,
                hasBorders: false,
                lockScalingFlip: true,
                lockRotation: true,
                crossOrigin: 'anonymous',
                isSticker: true
            });

            img.set({
                left: this.canvas.getWidth() / 2 - (img.width * scale) / 2,
                top: this.canvas.getHeight() / 2 - (img.height * scale) / 2
            });

            const showControls = () => {
                img.set({ hasControls: true, hasBorders: true, hasRotatingPoint: true });
                this.canvas.renderAll();
            };
            const hideControls = () => {
                img.set({ hasControls: false, hasBorders: false, hasRotatingPoint: false });
                this.canvas.renderAll();
            };

            img.on('mouseover', showControls);
            img.on('mouseout', hideControls);
            img.on('touchstart', showControls);
            img.on('touchend', hideControls);

            if (this.currentStickerObject) {
                this.canvas.remove(this.currentStickerObject);
            }

            this.currentStickerObject = img;
            this.canvas.add(img);
            this.canvas.setActiveObject(img);
            this.canvas.renderAll();
        }, { crossOrigin: 'anonymous' });
    }

    setupTextControls() {
        const textInput = document.getElementById('textInput');
        const addTextBtn = document.getElementById('addText');
        const fontSizeInput = document.getElementById('fontSize');
        const fontColorInput = document.getElementById('fontColor');
        const fontFamilyInput = document.getElementById('fontFamily');
        const boldBtn = document.getElementById('boldBtn');
        const italicBtn = document.getElementById('italicBtn');
        const underlineBtn = document.getElementById('underlineBtn');

        const createTextObject = (text) => {
            // remove existing textboxes
            this.canvas.getObjects().forEach(obj => {
                if (obj.type === 'textbox') this.canvas.remove(obj);
            });

            let fontSize = parseInt(fontSizeInput?.value || '30', 10) || 30;
            let fontColor = fontColorInput?.value || '#000000';
            let fontFamily = fontFamilyInput?.value || 'Arial';

            const textObj = new fabric.Textbox(text, {
                left: this.canvas.getWidth() / 2,
                top: this.canvas.getHeight() / 2,
                fontSize:fontSize,
                fill: fontColor,
                fontFamily,
                textAlign: 'center',
                editable: true,
                selectable: true,
                hasControls: false,
                hasBorders:false,
                lineHeight: 1
            });

            textObj.set({ originX: 'center', originY: 'center' });

            const showControls = () => {
                textObj.set({ hasControls: true, hasBorders: true, hasRotatingPoint: true });
                this.canvas.renderAll();
            };

            const hideControls = () => {
                textObj.set({ hasControls: false, hasBorders: false, hasRotatingPoint: false });
                this.canvas.renderAll();
            };

            textObj.on('mouseover', showControls);
            textObj.on('mouseout', hideControls);
            textObj.on('touchstart', showControls);
            textObj.on('touchend', hideControls);

            this.canvas.add(textObj);
            this.canvas.setActiveObject(textObj);
            this.canvas.renderAll();
        };

        // on typing (live)
        textInput?.addEventListener('input', (e) => {
            e.preventDefault();
            const text = textInput.value;
            if (text.trim() === '') return;
            createTextObject(text);
        });

        // on add button click
        addTextBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            const text = textInput.value;
            if (text.trim() === '') return;
            createTextObject(text);
        });


        fontColorInput?.addEventListener('input', function () {
            const active = thisRef.canvas.getActiveObject?.() ? null : null;
        });

        const thisRef = this;

        fontColorInput?.addEventListener('input', function () {
            const activeObj = thisRef.canvas.getActiveObject();
            if (activeObj && activeObj.type === 'textbox') {
                activeObj.set({ fill: this.value });
                thisRef.canvas.renderAll();
            }
        });

        fontSizeInput?.addEventListener('input', function () {
            const active = thisRef.canvas.getActiveObject();
            if (active && active.type === 'textbox') {
                active.set('fontSize', parseInt(this.value, 10));
                thisRef.canvas.renderAll();
            }
        });

        fontFamilyInput?.addEventListener('change', function () {
            const active = thisRef.canvas.getActiveObject();
            if (active && active.type === 'textbox') {
                active.set('fontFamily', this.value);
                thisRef.canvas.renderAll();
            }
        });

        boldBtn?.addEventListener('click', function () {
            const active = thisRef.canvas.getActiveObject();
            if (active && active.type === 'textbox') {
                active.set("fontWeight", active.fontWeight === "bold" ? "normal" : "bold");
                thisRef.canvas.renderAll();
                document.getElementById('FontWeight').value = active.fontWeight === "bold" ? 'Bold' : 'Normal';
                this.classList.toggle("active");
            }
        });

        italicBtn?.addEventListener('click', function () {
            const active = thisRef.canvas.getActiveObject();
            if (active && active.type === 'textbox') {
                active.set("fontStyle", active.fontStyle === "italic" ? "normal" : "italic");
                thisRef.canvas.renderAll();
                document.getElementById('FontStyle').value = active.fontStyle === "italic" ? 'Italic' : 'Normal';
                this.classList.toggle("active");
            }
        });

        underlineBtn?.addEventListener('click', function () {
            const active = thisRef.canvas.getActiveObject();
            if (active && active.type === 'textbox') {
                active.set("underline", !active.underline);
                thisRef.canvas.renderAll();
                document.getElementById('fontUnderline').value = active.underline ? 'Underline' : 'Normal';
                this.classList.toggle("active");
            }
        });

        // update controls UI when selecting text
        this.canvas.on('selection:created', () => this.updateTextControls());
        this.canvas.on('selection:updated', () => this.updateTextControls());
    }

    updateTextControls() {
        const active = this.canvas.getActiveObject();
        if (active && active.type === 'textbox') {
            const fs = document.getElementById('fontSize');
            const fc = document.getElementById('fontColor');
            const ff = document.getElementById('fontFamily');
            if (fc) fc.value = active.fill;
            if (ff) ff.value = active.fontFamily;
            if (fs) fs.value = active.fontSize;
        }
    }

    setupTabs() {
        const tabs = document.querySelectorAll('.customizer-tab');
        const tabContents = {
            0: document.getElementById('stickerTab'),
            1: document.getElementById('text-controls')
        };

        const personalisationInput = document.getElementById('personalisationInput');
        const dropdown = document.getElementById('personalisationDropdown');
        const selected = document.getElementById('selectedPersonalisation');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                Object.values(tabContents).forEach(panel => panel.style.display = 'none');
                tabContents[index].style.display = 'block';

                if (document.getElementById('fontFamily')) document.getElementById('fontFamily').value = 'Arial';
                if (personalisationInput) personalisationInput.value = tab.getAttribute('data-type') || '';

                if (tab.getAttribute('data-type') === 'message') {
                    this.switchToTab(1, 'message');
                    document.getElementById('textInput').value = '';
                    document.getElementById('fontSize').value = '50';
                    document.getElementById('fontColor').value = '';
                    document.getElementById('fontFamily').value = 'Arial';
                    document.getElementById('FontWeight').value = 'normal';
                    document.getElementById('FontStyle').value = 'normal';
                    document.getElementById('fontUnderline').value = 'normal';
                } else {
                    document.getElementById('textInput').value = '';
                    document.getElementById('fontSize').value = '';
                    document.getElementById('fontColor').value = '';
                    document.getElementById('fontFamily').value = 'Arial';
                    document.getElementById('FontWeight').value = '';
                    document.getElementById('FontStyle').value = '';
                    document.getElementById('fontUnderline').value = '';
                    this.switchToTab(0, tab.getAttribute('data-type'));
                    this.loadStickersForOccasion(document.getElementById('occasionInput')?.value || '');
                }

                // update dropdown visual
                const type = tab.getAttribute('data-type');
                if (type && personalisationInput && dropdown && selected) {
                    personalisationInput.value = type;
                    const matchingOption = dropdown.querySelector(`.dropdown-option[data-type="${type}"]`);
                    if (matchingOption) {
                        const img = matchingOption.querySelector('img')?.outerHTML || '';
                        const span = matchingOption.querySelector('span')?.outerHTML || '';
                        const chevron = selected.querySelector('svg')?.outerHTML || '';
                        selected.innerHTML = img + span + chevron;
                        dropdown.querySelectorAll('.dropdown-option').forEach(opt => opt.classList.remove('active'));
                        matchingOption.classList.add('active');
                    }
                }

                this.setProgressStep(2);
                if (typeof this.canvas !== 'undefined') {
                    const objs = this.canvas.getObjects();
                    if (objs.length > 0) {
                        this.canvas.remove(objs[0]);
                        this.canvas.renderAll();
                    }
                }
            });
        });

        // dropdowns inside personalisation options
        document.querySelectorAll('#personalisationOptions .dropdown-option').forEach(option => {
            option.addEventListener('click', () => {
                const selectedType = option.getAttribute('data-type') || '';
                const personalisationInput = document.getElementById('personalisationInput');
                if (personalisationInput) personalisationInput.value = selectedType;

                if (selectedType === 'message') {
                    this.switchToTab(1, selectedType);
                    // reset text controls
                    document.getElementById('textInput').value = '';
                    document.getElementById('fontSize').value = '50';
                    document.getElementById('fontColor').value = '';
                    document.getElementById('fontFamily').value = 'Arial';
                    document.getElementById('FontWeight').value = 'normal';
                    document.getElementById('FontStyle').value = 'normal';
                    document.getElementById('fontUnderline').value = 'normal';
                } else {
                    document.getElementById('textInput').value = '';
                    document.getElementById('fontSize').value = '';
                    document.getElementById('fontColor').value = '';
                    document.getElementById('fontFamily').value = 'Arial';
                    document.getElementById('FontWeight').value = '';
                    document.getElementById('FontStyle').value = '';
                    document.getElementById('fontUnderline').value = '';
                    this.switchToTab(0, selectedType);
                }
            });
        });
    }

    switchToTab(index, selectType = '') {
        const tabs = document.querySelectorAll('.customizer-tab');
        const panels = document.querySelectorAll('.tab-content');

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.style.display = 'none');

        if (tabs[index] && selectType !== '') {
            tabs[index].classList.add('active');
            tabs[index].click();
        } else {
            document.getElementById('stickerTab').style.display = 'none';
            document.getElementById('text-controls').style.display = 'none';
            this.setProgressStep(1);
            if (typeof this.canvas !== 'undefined') {
                const objs = this.canvas.getObjects();
                if (objs.length > 0) {
                    this.canvas.remove(objs[0]);
                    this.canvas.renderAll();
                }
            }
        }
    }

    setProgressStep(index) {
        const steps = document.querySelectorAll('.progress-step');
        steps.forEach((step, i) => step.classList.toggle('active', i === index));
    }

    // Build properties and upload previews
    buildLineItemProperties_OLD() {
        return new Promise((resolve) => {
            const properties = {};
            const uploads = [];
            const occasion = document.querySelector('#occasionInput')?.value || '';
            const personalisation = document.getElementById('personalisationInput')?.value || '';

            if (occasion) properties["Occasion"] = occasion;
            if (personalisation) properties["Personalisation"] = personalisation;

            // Sticker
            if (personalisation === "sticker") {
                const stickerTitle = document.querySelector('.sticker-option.selected img')?.alt;
                const stickerImage = document.querySelector('.sticker-option.selected img')?.src;
                if (stickerTitle && stickerImage) properties["Sticker"] = `${stickerTitle} | ${stickerImage}`;
            }

            // Message preview upload (if text active)
            if (personalisation === "message") {
                const text = document.getElementById("textInput")?.value;
                const fontSize = document.getElementById("fontSize")?.value;
                const fontColor = document.getElementById("fontColor")?.value;
                const fontFamily = document.getElementById("fontFamily")?.value;
                const bold = document.getElementById("FontWeight")?.value;
                const italic = document.getElementById("FontStyle")?.value;
                const underline = document.getElementById("fontUnderline")?.value;

                if (text) properties["Message"] = text;
                if (fontSize) properties["Font-Size"] = fontSize;
                if (fontColor) properties["Font-Color"] = fontColor;
                if (fontFamily) properties["Font-Family"] = fontFamily;
                properties["Font-Weight"] = bold;
                properties["Font-Style"] = italic;
                properties["Font-Underline"] = underline;

                const inputText = document.getElementById('textInput')?.value || '';
                const formattedText = inputText.replace(/\s+/g, '-');

                const activeObj = this.canvas.getActiveObject();
                if (activeObj) {
                    const uploadTextPreview = new Promise((resolveText) => {
                        activeObj.clone(clone => {
                            clone.set({ originX: 'left', originY: 'top' });
                            const bounds = clone.getBoundingRect(true, true);
                            const padding = 30;

                            const tempCanvas = new fabric.StaticCanvas(null, {
                                width: bounds.width + padding * 2,
                                height: bounds.height + padding * 2,
                                backgroundColor: 'transparent'
                            });

                            clone.set({ left: padding, top: padding });
                            tempCanvas.add(clone);
                            tempCanvas.renderAll();

                            tempCanvas.getElement().toBlob(blob => {
                                const formData = new FormData();
                                formData.append("image", blob);
                                formData.append("name", formattedText + '-text-preview');

                                const imgbbApiKey = "80c8f21e2d42326b684fc293add93ac0";

                                fetch(`https://api.imgbb.com/1/upload?key=${imgbbApiKey}`, {
                                    method: "POST",
                                    body: formData
                                }).then(res => res.json())
                                    .then(data => {
                                        if (data?.data?.url) properties["Custom-Text-Preview"] = `${data.data.url}`;
                                        resolveText();
                                    })
                                    .catch(() => resolveText());
                            }, 'image/png');
                        });
                    });
                    uploads.push(uploadTextPreview);
                }
            }

            // Main canvas upload (always)
            const canvasEl = document.getElementById(this.canvasElId);
            if (canvasEl) {
                const uploadMainPreview = new Promise((resolveMain) => {
                    canvasEl.toBlob(blob => {
                        const formData = new FormData();
                        formData.append("image", blob);
                        formData.append("key", "80c8f21e2d42326b684fc293add93ac0");
                        formData.append("name", 'customizer-image');

                        fetch("https://api.imgbb.com/1/upload", {
                            method: "POST",
                            body: formData
                        }).then(res => res.json())
                            .then(data => {
                                if (data?.success && data?.data?.url) {
                                    properties["Custom-Preview"] = `${data.data.url}`;
                                }
                                resolveMain();
                            }).catch(() => resolveMain());
                    }, 'image/png');
                });
                uploads.push(uploadMainPreview);
            }

            if (uploads.length > 0) {
                Promise.all(uploads).then(() => resolve(properties)).catch(() => resolve(properties));
            } else {
                resolve(properties);
            }
        });
    }

    buildLineItemProperties() {
        return new Promise((resolve) => {
            // language from class (en / fr / de)
            const lang = (this.currentLanguage || 'en').toLowerCase();

            // Property labels per language
            const PROPERTY_LABELS = {
                "Occasion": {
                    en: "Occasion",
                    fr: "Occasion",
                    de: "Anlass"
                },
                "Personalisation": {
                    en: "Personalisation",
                    fr: "Personnalisation",
                    de: "Personalisierung"
                },
                "Sticker": {
                    en: "Image",
                    fr: "Image",
                    de: "Bild"
                },
                "Message": {
                    en: "Message",
                    fr: "Message",
                    de: "Nachricht"
                },
                "Font-Size": {
                    en: "Font Size",
                    fr: "Taille de police",
                    de: "Schriftgröße"
                },
                "Font-Color": {
                    en: "Font Color",
                    fr: "Couleur de police",
                    de: "Schriftfarbe"
                },
                "Font-Family": {
                    en: "Font Family",
                    fr: "Police",
                    de: "Schriftart"
                },
                "Font-Weight": {
                    en: "Font Weight",
                    fr: "Graisse de police",
                    de: "Schriftstärke"
                },
                "Font-Style": {
                    en: "Font Style",
                    fr: "Style de police",
                    de: "Schriftstil"
                },
                "Font-Underline": {
                    en: "Underline",
                    fr: "Soulignement",
                    de: "Unterstrichen"
                },
                "Custom-Preview": {
                    en: "Custom Preview",
                    fr: "Aperçu personnalisé",
                    de: "Benutzerdefinierte Vorschau"
                },
                "Custom-Text-Preview": {
                    en: "Text Preview",
                    fr: "Aperçu du texte",
                    de: "Textvorschau"
                }
            };

            const t = (key) => {
                const entry = PROPERTY_LABELS[key];
                if (!entry) return key;
                return entry[lang] || entry.en || key;
            };

            console.log('TEST',t("Occasion"));
            const properties = {};
            const uploads = [];

            const occasion = document.querySelector('#occasionInput')?.value || '';
            const personalisation = document.getElementById('personalisationInput')?.value || '';

            if (occasion) {
                properties[t("Occasion")] = occasion;
            }
            if (personalisation) {
                if(personalisation == 'sticker'){
                    properties[t("Personalisation")] = t("Sticker");
                }else{
                    properties[t("Personalisation")] = t("Message");
                }

            }

            // ------ STICKER PROPERTIES ------
            if (personalisation === "sticker") {
                const imgEl = document.querySelector('.sticker-option.selected img');
                const stickerTitle = imgEl?.alt;
                const stickerImage = imgEl?.src;
                if (stickerTitle && stickerImage) {
                    properties[t("Sticker")] = `${stickerTitle} | ${stickerImage}`;
                }
            }

            // ------ MESSAGE PROPERTIES + TEXT PREVIEW UPLOAD ------
            if (personalisation === "message") {
                const text       = document.getElementById("textInput")?.value;
                const fontSize   = document.getElementById("fontSize")?.value;
                const fontColor  = document.getElementById("fontColor")?.value;
                const fontFamily = document.getElementById("fontFamily")?.value;
                const bold       = document.getElementById("FontWeight")?.value;
                const italic     = document.getElementById("FontStyle")?.value;
                const underline  = document.getElementById("fontUnderline")?.value;

                if (text)       properties[t("Message")]        = text;
                if (fontSize)   properties[t("Font-Size")]      = fontSize;
                if (fontColor)  properties[t("Font-Color")]     = fontColor;
                if (fontFamily) properties[t("Font-Family")]    = fontFamily;
                properties[t("Font-Weight")]    = bold;
                properties[t("Font-Style")]     = italic;
                properties[t("Font-Underline")] = underline;

                const inputText = document.getElementById('textInput')?.value || '';
                const formattedText = inputText.replace(/\s+/g, '-');

                const activeObj = this.canvas?.getActiveObject && this.canvas.getActiveObject();
                if (activeObj) {
                    const uploadTextPreview = new Promise((resolveText) => {
                        activeObj.clone((clone) => {
                            // Prepare small temp canvas around the text only
                            clone.set({ originX: 'left', originY: 'top' });
                            const bounds = clone.getBoundingRect(true, true);
                            const padding = 30;

                            const tempCanvas = new fabric.StaticCanvas(null, {
                                width: bounds.width + padding * 2,
                                height: bounds.height + padding * 2,
                                backgroundColor: 'transparent'
                            });

                            clone.set({ left: padding, top: padding });
                            tempCanvas.add(clone);
                            tempCanvas.renderAll();

                            tempCanvas.getElement().toBlob((blob) => {
                                const formData = new FormData();
                                formData.append("image", blob);
                                formData.append("name", formattedText + '-text-preview');

                                const imgbbApiKey = "80c8f21e2d42326b684fc293add93ac0";

                                fetch(`https://api.imgbb.com/1/upload?key=${imgbbApiKey}`, {
                                    method: "POST",
                                    body: formData
                                })
                                    .then(res => res.json())
                                    .then(data => {
                                        if (data?.data?.url) {
                                            properties[t("Custom-Text-Preview")] = `${data.data.url}`;
                                        }
                                        resolveText();
                                    })
                                    .catch(() => resolveText());
                            }, 'image/png');
                        });
                    });

                    uploads.push(uploadTextPreview);
                }
            }

            // ------ MAIN CANVAS PREVIEW UPLOAD (ALWAYS) ------
            const canvasEl = document.getElementById('macaronCanvas');
            if (canvasEl) {
                const uploadMainPreview = new Promise((resolveMain) => {
                    canvasEl.toBlob((blob) => {
                        const formData = new FormData();
                        formData.append("image", blob);
                        formData.append("key", "80c8f21e2d42326b684fc293add93ac0");
                        formData.append("name", 'customizer-image');

                        fetch("https://api.imgbb.com/1/upload", {
                            method: "POST",
                            body: formData
                        })
                            .then(res => res.json())
                            .then(data => {
                                if (data?.success && data?.data?.url) {
                                    properties[t("Custom-Preview")] = `${data.data.url}`;
                                }
                                resolveMain();
                            })
                            .catch(() => resolveMain());
                    }, 'image/png');
                });

                uploads.push(uploadMainPreview);
            }

            // ------ RESOLVE ALL UPLOADS ------
            if (uploads.length > 0) {
                Promise.all(uploads)
                    .then(() => resolve(properties))
                    .catch(() => resolve(properties)); // fail-safe
            } else {
                resolve(properties);
            }
        });
    }


    setupAddToCart() {
        const addBtn = document.getElementById('AddToCartBtn');
        addBtn?.addEventListener('click', async (e) => {
            e.preventDefault();
            const occasion = document.querySelector('#occasionInput')?.value?.trim() || '';
            if (!occasion) {
                this.showOccasionValidation();
                return;
            }

            this.clearOccasionValidation();

            const mainVariantId = document.querySelector('form [name="id"]')?.value;
            try {
                const properties = await this.buildLineItemProperties();
                const items = [{ id: mainVariantId, quantity: 1, properties }];
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                });
                await res.json();
                window.location.href = `/${this.currentLanguage}/cart`;
            } catch (err) {
                // intentionally silent as original
                console.error('Add to cart failed', err);
            }
        });
    }

    setupPickr() {
        if (typeof Pickr === 'undefined') return;
        const pickr = Pickr.create({
            el: '#color-picker',
            theme: 'classic',
            default: '#000000',
            swatches: ['#000000', '#C20404', '#0F30DA', '#4B7600', '#CDB30C', '#FC6ED9'],
            components: {
                preview: true,
                opacity: true,
                hue: true,
                interaction: { input: true, save: false }
            }
        });

        pickr.on('change', (color) => {
            const hex = color.toHEXA().toString();
            document.getElementById('fontColor').value = hex;
            const activeObj = this.canvas.getActiveObject();
            if (activeObj && activeObj.type === 'textbox') {
                activeObj.set({ fill: hex });
                this.canvas.renderAll();
            }
        });
    }

    autoSelectFirsts() {
        const firstOption = document.querySelector('#occasionOptions .dropdown-option');
        if (firstOption) firstOption.click();

        const firstMacaron = document.querySelector('.c-configurator__flavors-box .macaron-option');
        if (firstMacaron) firstMacaron.click();
    }
}


document.addEventListener("DOMContentLoaded", function () {
    // if you need to pass an initial selected occasion or canvas id, provide options
    new MacaronCustomizer({});
});
